import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
} from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ReactSignatureCanvas from "react-signature-canvas";
import AlertDialog from "../AlertDialog/AlertDialog";

export default function SignatureCanvasDialog({
    isOpen,
    onClose,
    onDigitalSign,
}) {
    const [isEmptyOpen, setIsEmptyOpen] = useState(false);
    const { t } = useTranslation();
    let sigCanvas;
    const onClearSignature = () => {
        sigCanvas.clear();
    };
    const onSignSubmit = () => {
        if (sigCanvas.isEmpty()) {
            setIsEmptyOpen(true);
        } else {
            const dataURL = sigCanvas.toDataURL();
            onDigitalSign(dataURL);
        }
    };
    return (
        <Dialog
            onClose={onClose}
            aria-labelledby="handwrite-signing-dialog"
            open={isOpen}
        >
            <DialogTitle id="signature-dialog-title">
                {t("common.signCanvas.signingBox")}
                <IconButton aria-label="cancel" onClick={onClose}>
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Box style={{ border: "1px solid" }}>
                    <ReactSignatureCanvas
                        penColor="green"
                        canvasProps={{
                            width: 500,
                            height: 200,
                        }}
                        ref={(ref) => {
                            sigCanvas = ref;
                        }}
                    />
                    <AlertDialog
                        formOpen={isEmptyOpen}
                        content={t("common.signCanvas.empty")}
                        confirmButton={{
                            action: () => setIsEmptyOpen(false),
                            label: t("common.confirm"),
                        }}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClearSignature}>
                    {t("common.signCanvas.clear")}
                </Button>
                <Button onClick={onSignSubmit}>
                    {t("common.signCanvas.submit")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
